module.exports = "/images/milano-12.jpg";